import cx from "classnames";
import styles from "./SectionArticle.module.scss";
import Article from "@components/Story/Article";
// import Button from "@components/Button";
import _ from "lodash";
import { useTranslationContext } from "@providers/TranslationProvider";

const View = ({ light }: any) => {
  const { i18n } = useTranslationContext();
  return (
    <section data-scroll-section className={styles.section}>
      {/* <Divider className={styles.divider} color="black-1" opacity="100" /> */}
      <div
        className={cx(
          "inner-large ama-section-title text-black-1 text-center",
          styles.title
        )}
      >
        {i18n.t("Stories.lastestStories")}
      </div>
      <div className="inner-large">
        <Article light={light} />
      </div>
      {/* <div className="flex justify-center pb-[5rem]">
        <Button label="explore more" />
      </div> */}
    </section>
  );
};
export default View;
